import { CSSObject } from "@emotion/react";
import {
  typographyStyles,
  constants,
  mediaQueryStyles,
} from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  breakpoints: {
    BreakpointNames: { sm, md },
  },
  colors: { ui },
} = constants;
const { heading4Obj } = typographyStyles;

export const rowContainerCss: CSSObject = {
  [mq.upTo(sm)]: {
    padding: "16px",
  },
  backgroundColor: ui.white[25],
  borderRadius: "16px",
  display: "grid",
  gap: "20px",
  padding: "24px",
  position: "relative",
};

export const rowTitleContainerCss: CSSObject = {
  display: "flex",
};

export const rowTitleCss = {
  ...heading4Obj,
  fontWeight: 700,
  margin: "0",
};

export const sharedUlCss = {
  listStyle: "none",
  margin: 0,
  padding: 0,
};

export const customResourcesCss: CSSObject = {
  ...sharedUlCss,
  columnCount: 3,
  maxWidth: "75%",
  columnGap: "64px",

  [mq.upTo(md)]: {
    columnCount: 1,
    maxWidth: "100%",
  },
};

export const contentContainerCss: CSSObject = {
  [mq.upTo(sm)]: {
    "--gap": 0,
    rowGap: "16px",
  },
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  width: "100%",
  "--gap": "16px",
  gap: "var(--gap)",
  ...sharedUlCss,
  ">*": {
    [mq.upTo(sm)]: {
      width: "100%",
    },
    maxWidth: "calc(50% - calc(var(--gap) / 2))",
    flex: "1 1 calc(25% - calc(var(--gap) * 3))",
    boxSizing: "border-box",
  },
};

export const editButtonCss = {
  margin: "0px 20px",
};

export const backgroundImageCss: CSSObject = {
  bottom: 0,
  position: "absolute",
  right: "24px",
  height: "155px",
  maxHeight: "90%",

  svg: {
    height: "100%",
  },

  [mq.upTo(md)]: {
    display: "none",
  },
};
